import mascot from "@/assets/healic-mascot-transparent.png.asset.json";

type Size = "sm" | "md" | "lg";

const sizeMap: Record<Size, string> = {
  sm: "h-12 w-12 sm:h-14 sm:w-14",
  md: "h-16 w-16 sm:h-20 sm:w-20",
  lg: "h-20 w-20 sm:h-24 sm:w-24",
};

export function HealicMascot({
  size = "md",
  className = "",
  alt = "Healic mascot — caring doctor",
}: {
  size?: Size;
  className?: string;
  alt?: string;
}) {
  return (
    <img
      src={mascot.url}
      alt={alt}
      loading="lazy"
      decoding="async"
      width={96}
      height={96}
      className={`inline-block select-none object-contain ${sizeMap[size]} ${className}`}
      draggable={false}
    />

  );
}
